import * as messages from "../../messages";
import { genericUpdate } from "../../utils/generic_update";
import { KeyedList } from "../../utils/List";

export interface AppVisitEditRequestsState {
  readonly visitEditRequests: KeyedList<messages.CaregiverVisitEditRequest, "visitId">;
}

export class AppVisitEditRequestsState {
  static fromMessage(message: messages.CaregiverVisitEditRequest[]): AppVisitEditRequestsState {
    return {
      visitEditRequests: KeyedList.from<messages.CaregiverVisitEditRequest>(message)("visitId"),
    };
  }

  static updateFromMessage(
    appVisitEditRequestsState: AppVisitEditRequestsState,
    message: messages.CaregiverVisitEditRequest[]
  ): AppVisitEditRequestsState {
    return genericUpdate(appVisitEditRequestsState, AppVisitEditRequestsState.fromMessage(message));
  }
}
